// Brand registry. Register every brand here; the active one is chosen by
// REACT_APP_BRAND at build/run time (see theme/index.js).

import revivo from "./revivo";
import karuna from "./karuna";

export const DEFAULT_BRAND = "revivo";

export const brands = {
  revivo,
  karuna,
};

export default brands;
